module.exports = __webpack_public_path__ + "static/media/card.e1df21e2.png";